<div class="container-fluid mb-3">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h2 class="title">DocStore</h2>
    <div class="d-flex justify-content-center align-items-center">
      <button class="btn btn-primary mr-3 btn-add button" (click)="exportDocStoreUsers()">Export</button>
      <button class="btn btn-primary btn-add button" (click)="addNewRole()">Add</button>
    </div>
  </div>
  <mat-card class="mt-2" style="font-size: 14px;">
    <div class="row">
      <div class="col-lg-8">
        <span>Search</span>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput [maxLength]="50" [(ngModel)]="search" placeholder="Search">
          <mat-hint align="end">{{search?.length || 0}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-lg-2">
        <span>Role</span>
        <mat-form-field appearance="outline" class="w-100">
          <mat-select [(ngModel)]="role">
            <mat-option *ngFor="let role of roles" [value]="role.value">{{role.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-2 d-flex align-items-center justify-content-center">
        <button class="btn-add btn btn-outline-primary search-button" (click)="searchData()">Search</button>
      </div>
    </div>
  </mat-card>
  <table mat-table [dataSource]="dataSource" matSort class=" w-100 mt-4" (matSortChange)="sortData($event)">

    <!-- SSO column -->
    <ng-container matColumnDef="sso">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bold-header"> SSO </th>
      <td mat-cell *matCellDef="let row"> {{row.sso}} </td>
    </ng-container>

    <!-- Full Name column -->
    <ng-container matColumnDef="full_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Full Name </th>
      <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
    </ng-container>

    <!-- Email column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
      <td mat-cell *matCellDef="let row"> {{row.email}} </td>
    </ng-container>

    <!-- Role column -->
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
      <td mat-cell *matCellDef="let row"> {{convertRoleToName(row.roles[0])}} </td>
    </ng-container>

    <!-- Last Access column -->
    <ng-container matColumnDef="last_access">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Access </th>
      <td mat-cell *matCellDef="let row"> {{row.lastAccess}} </td>
    </ng-container>

    <!-- Action column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action </th>
      <td mat-cell *matCellDef="let row" style="text-align: center;">
        <div class="d-flex justify-content-center align-items-center">
          <span class="material-icons action" (click)="edit(row.id)" style="cursor: pointer;" [matTooltip]="'Edit'">
            create </span>
          <i class="fa fa-trash px-2 action delete" aria-hidden="true" [matTooltip]="'Remove'"
            (click)="deleteUser(row?.id)" style="cursor: pointer; font-size:23px"></i>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <app-ngx-mat-paginator class="w-100" *ngIf="!!dataSource && dataSource.data.length > 0"
    [requestOption]="requestOption" (requestOptionChange)="onChangeRequestOption($event)"></app-ngx-mat-paginator>
</div>